import { nestedAppAuth } from '@microsoft/teams-js';
import { endAndReportPerformanceMeasure, startPerformanceMeasure } from '@ms/yammer-data/dist/telemetry';

import { ensureInitializedWithTelemetry as ensureTeamsSDKInitializedWithTelemetry } from './initialize';

type IsNAAChannelRecommended = () => Promise<boolean>;
export const isNAAChannelRecommendedWithTelemetry: IsNAAChannelRecommended = async () => {
  await ensureTeamsSDKInitializedWithTelemetry();

  let isNAAChannelRecommendedResult = false;
  let endedWithError = false;
  const measure = startPerformanceMeasure('meta_os_hub_is_naa_channel_recommended');

  try {
    isNAAChannelRecommendedResult = await nestedAppAuth.isNAAChannelRecommended();
  } catch (error) {
    endedWithError = true;
  } finally {
    endAndReportPerformanceMeasure({ ...measure, eventProperties: { ...measure.eventProperties, endedWithError } });
  }

  return isNAAChannelRecommendedResult;
};
